import { render, staticRenderFns } from "./GridCuadraturaAnt.vue?vue&type=template&id=63d50f22&"
import script from "./GridCuadraturaAnt.vue?vue&type=script&lang=js&"
export * from "./GridCuadraturaAnt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports